export const maxScores = {
  verbalFluency: '-',
  naming: 15,
  mmse: 30,
  wordListTrial1: 10,
  wordListTrial2: 10,
  wordListTrial3: 10,
  wordListLearningTotal: 30,
  copyFigure1: 2,
  copyFigure2: 3,
  copyFigure3: 2,
  copyFigure4: 4,
  copyFigureTotal: 11,
  wordListDelayedRecallRaw: 10,
  wordListDelayedRecallRetentionPercentage: 100,
  wordListRecognitionYes: 10,
  wordListRecognitionNo: 10,
  wordListRecognitionTotal: 20,
  delayedFigure1: 2,
  delayedFigure2: 3,
  delayedFigure3: 2,
  delayedFigure4: 4,
  delayedFiguresTotal: 11,
  delayedFiguresRetentionPercentage: 100,
  clockDrawing: 6,
  total: 111,
};

export const cutOffScoresByEducationYears: { [key: string]: { [key: string]: number } } = {
  '≤10': {
    verbalFluency: 18,
    naming: 12,
    wordListLearningTotal: 17,
    wordListDelayedRecallRetentionPercentage: 65,
    wordListRecognitionTotal: 19,
    delayedFiguresRetentionPercentage: 65,
    clockDrawing: 5,
    total: 72,
  },
  '≥11': {
    verbalFluency: 19,
    naming: 13,
    wordListLearningTotal: 18,
    wordListDelayedRecallRetentionPercentage: 75,
    wordListRecognitionTotal: 19,
    delayedFiguresRetentionPercentage: 75,
    clockDrawing: 5,
    total: 82,
  },
};

export const taskToTitleMap: { [key: string]: string } = {
  wordListTrial1: 'wordListLearning',
  wordListTrial2: 'wordListLearning',
  wordListTrial3: 'wordListLearning',
  wordListLearningTotal: 'wordListLearning',
  copyFigure1: 'copyFigure',
  copyFigure2: 'copyFigure',
  copyFigure3: 'copyFigure',
  copyFigure4: 'copyFigure',
  copyFigureTotal: 'copyFigure',
  wordListDelayedRecallRaw: 'wordListDelayedRecall',
  wordListDelayedRecallRetentionPercentage: 'wordListDelayedRecall',
  wordListRecognitionYes: 'wordListRecognition',
  wordListRecognitionNo: 'wordListRecognition',
  wordListRecognitionTotal: 'wordListRecognition',
  delayedFigure1: 'delayedFigure',
  delayedFigure2: 'delayedFigure',
  delayedFigure3: 'delayedFigure',
  delayedFigure4: 'delayedFigure',
  delayedFiguresTotal: 'delayedFigure',
  delayedFiguresRetentionPercentage: 'delayedFigure',
};
